import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";

interface IGetDataProps {
  token?: string;
  label: string;
}

export const QUERY_KEY_FOR_SUBSCRIPTION_RULES_STATUS =
  "SubscriptionRulesStatus";

export const getSubscriptionRulesStatus = async (
  props: IGetDataProps,
): Promise<any> => {
  const url = `${END_POINT.BASE_URL}/v1/subscription-rules/status`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, {
    ...config,
    params: { label: props.label },
  });
  return res.data.data || res.data;
};

export const useGetSubscriptionRulesStatus = (props: IGetDataProps) => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_SUBSCRIPTION_RULES_STATUS, props.label],
    () =>
      getSubscriptionRulesStatus({
        ...props,
        token,
      }),
    {
      onError: (err: any) => {
        console.error(
          "Error fetching subscription rules status:",
          err.response.data,
        );
      },
      onSuccess: (data) => {
        console.log(
          "Subscription rules status fetched successfully:",
          data.data,
        );
      },
      enabled: !!token && !!props.label,
    },
  );
  return queryData;
};
